import {Card, GroupContainer} from '@mc/ui-v4';

import React, {useEffect} from 'react';
import {useQuery} from 'react-query';
import {JsonImportApi, JsonImportProgressVO, JsonImportState} from '../../../api';
import {JsonImportProgressContent} from './JsonImportProgressContent';

const POLL_INTERVAL_MS = 1000;

export const jsonImportProgressForLayerKey = (layerId: number) => ['jsonImportProgressForLayer', layerId];

export const JsonImportLayerProgress: React.FC<{layerId: number}> = ({layerId}) => {
    const {data, refetch} = useQuery<JsonImportProgressVO | null>(
        jsonImportProgressForLayerKey(layerId),
        async () => (await JsonImportApi.getJsonImportProgressForLayer(layerId)).data || null,
        {enabled: !!layerId, refetchOnWindowFocus: false},
    );

    const running = data?.state === JsonImportState.RUNNING;

    useEffect(() => {
        if (!running) {
            return;
        }
        const id = setInterval(() => {
            void refetch();
        }, POLL_INTERVAL_MS);
        return () => clearInterval(id);
    }, [running, refetch]);

    if (!data || data.state !== JsonImportState.RUNNING) {
        return null;
    }

    return (
        <div className="mb-2">
            <GroupContainer title={'Import dat z JSON'}>
                <Card mode={'view'}>
                    <div className="p-3">
                        <JsonImportProgressContent progress={data} />
                    </div>
                </Card>
            </GroupContainer>
        </div>
    );
};
